<template>
  <div id="AppPasswordInitialization" class="login-background-color">
    <img src="@/assets/logo.png" style="height: 250px; margin: 50px" />
    <div>
      <p>Philips Care Portal</p>
    </div>
    <section style="width: 500px; margin: auto">
      <template v-if="view == 'sendPass'">
        <b-field
          label="ログイン用のメールアドレスを入力してください。"
          :type="{ 'is-danger': errors.has('loginmail') }"
          :message="errors.first('loginmail')"
        >
          <b-input
            name="loginmail"
            data-vv-as="ログイン用メールアドレス"
            type="text"
            v-model="loginmail"
            v-validate="'required|email2|max:100'"
            placeholder="メールアドレスを入力してください"
            maxlength="100"
          ></b-input>
        </b-field>
        <b-field
          label="パスフレーズ受信用の携帯電話またはEメールアドレスを入力してください。"
          :type="{ 'is-danger': errors.has('passphraseAddress') }"
          :message="errors.first('passphraseAddress')"
        >
          <b-input
            name="passphraseAddress"
            data-vv-as="パスフレーズ用の連絡先"
            type="text"
            v-model="passphraseAddress"
            v-validate="'required|max:100'"
            placeholder="携帯番号またはメールアドレスを入力してください"
            maxlength="100"
          ></b-input>
        </b-field>
      </template>
      <template v-if="view == 'inputPass'">
        <b-field label="受信したパスフレーズを入力して" />
        <b-field label="パスワード初期化メール送信ボタンを押してください。" />
        <b-field
          :type="{ 'is-danger': errors.has('passphrase') }"
          :message="errors.first('passphrase')"
        >
          <b-input
            name="passphrase"
            data-vv-as="パスフレーズ"
            type="text"
            v-model="passphrase"
            v-validate="'required|max:100'"
            placeholder="パスフレーズを入力してください"
            maxlength="100"
            @keydown.enter.native="passPhraseAreaEnter"
          ></b-input>
        </b-field>
      </template>
    </section>
    <footer class="login-footer">
      <div>
        <template v-if="view == 'sendPass'">
          <b-button
            class="button is-primary is-inverted"
            :disabled="!isActive"
            v-on:click="sendPassPhrase"
            style="
              width: 500px;
              margin: 0 0 5px 0;
              background-color: #00325d;
              color: whitesmoke;
            "
            >パスフレーズ送信</b-button
          >
          <b-button
            class="button is-light is-inverted"
            type="button"
            :disabled="!isActive"
            v-on:click="back"
            style="
              width: 500px;
              margin: 0 0 5px 0;
              background-color: #00325d;
              color: whitesmoke;
            "
            >ログインへ戻る</b-button
          >
        </template>
        <template v-if="view == 'inputPass'">
          <b-button
            class="button is-primary is-inverted has-text-centered"
            icon-left="send"
            :disabled="!isActive"
            v-on:click="sendPasswordMail"
            style="width: 250px"
            >パスワード初期化メール送信</b-button
          >
          <b-button
            class="button is-light is-inverted has-text-centered"
            type="button"
            :disabled="!isActive"
            v-on:click="back"
            style="width: 150px"
            >ログインへ戻る</b-button
          >
        </template>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "AppPasswordInitialization",
  methods: {
    back: function (event) {
      console.log("back called.");
      this.$router.go(-1);
    },
    sendPasswordMail: function (event) {
      console.log("sendPasswordMail called.");
      this.isActive = false;
      this.$validator.validateAll().then((result) => {
        this.$store
          .dispatch("passwordinit", {
            mail: this.loginmail,
            passphrase: this.passphrase,
          })
          .then((result) => {
            console.log(result);
            if (result != null && result.status === 200) {
              this.isActive = true;
              this.showSuccess(result);
              if (this.$route.query && this.$route.query.query) {
                this.$router.push({
                  path: "/",
                  query: { query: this.$route.query.query },
                });
              } else {
                this.$router.push({ path: "/" });
              }
            } else if (
              result != null &&
              (result.status === 400 ||
                result.status === 401 ||
                result.status === 500)
            ) {
              var message = "予期しないエラーが発生しました。";
              if (this.sendPasswordMailErrorCount > 4) {
                //メッセージ（5回失敗しました。再度ログイン画面に戻ります。）
                this.showErrorMessage(
                  "試行回数が制限に達しました。ログイン画面に戻ります。"
                );
                this.$router.push({ path: "/" });
              } else {
                if (result.response.body) {
                  message = result.response.body.message;
                } else if (result.message) {
                  message = esult.message;
                }
                this.showErrorMessage(message);
                this.sendPasswordMailErrorCount += 1;
              }
              this.isActive = true;
            } else {
              this.showErrorMessage("予期しないエラーが発生しました。");
              this.isActive = true;
            }
          })
          .catch((error) => {
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。");
            this.isActive = true;
          });
      });
    },
    passPhraseAreaEnter: function() {
      if(this.passphrase){
        this.sendPasswordMail();
      }
    },
    sendPassPhrase: function () {
      console.log("sendPasswordMail called.");
      this.isActive = false;
      this.$validator.validateAll().then((result) => {
        this.$store
          .dispatch("sendPassphraseForPasswordinitPOST", {
            loginmail: this.loginmail,
            passphraseAddress: this.passphraseAddress,
          })
          .then((result) => {
            console.log(result);
            if (result != null && result.status === 200) {
              this.isActive = true;
              this.view = "inputPass";
            } else if (
              result != null &&
              (result.status === 400 ||
                result.status === 401 ||
                result.status === 500)
            ) {
              var message = "予期しないエラーが発生しました。";
              if (result.response.body) {
                message = result.response.body.message;
              } else if (result.message) {
                message = esult.message;
              }
              this.showErrorMessage(message);
              this.isActive = true;
            } else {
              this.showErrorMessage("予期しないエラーが発生しました。");
              this.isActive = true;
            }
          })
          .catch((error) => {
            this.showErrorMessage(error);
            this.isActive = true;
          });
      });
    },
    showDialog: function (message) {
      this.$dialog.alert({
        title: "　",
        message: message,
      });
    },
  },
  data() {
    return {
      isActive: true,
      loginmail: "",
      passphraseAddress: "",
      passphrase: "",
      view: "sendPass",
      sendPasswordMailErrorCount: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$background: #061e57;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black,
  ),
  "black": (
    $black,
    $white,
  ),
  "light": (
    $light,
    $light-invert,
  ),
  "dark": (
    $dark,
    $dark-invert,
  ),
  "primary": (
    $primary,
    $primary-invert,
  ),
  "info": (
    $info,
    $info-invert,
  ),
  "success": (
    $success,
    $success-invert,
  ),
  "warning": (
    $warning,
    $warning-invert,
  ),
  "danger": (
    $danger,
    $danger-invert,
  ),
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
.passphrase_txt {
  margin-left: 30px;
  margin-bottom: 32px;
  text-align: left;
}
.modal-card-head,
.modal-card-foot {
  background: linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  background: -moz-linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  background: -webkit-linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
}
.modal-card-title {
  color: whitesmoke;
}
ul {
  text-align: center;
  margin-left: -10px;
  font-size: 0; /* タグ改行時の空白防止 */
}

ul li {
  display: inline-block;
  margin-left: 30px;
  font-size: 14px; /* ulでサイズ0にしたのを戻す */
}
.modal-card-title {
  font-size: 1.4rem;
}
.copyright_area {
  margin-top: 10px;
}
.copyright {
  font-size: small;
}
.login-background-color {
  background: -moz-radial-gradient(#0077cd 20%, #00325d 85%);
  background: -webkit-radial-gradient(#0077cd 20%, #00325d 85%);
  background: radial-gradient(#0077cd 20%, #00325d 85%);
  height: 100%;
  width: 100%;
  position: absolute;
  transform-origin: 0% 0%;
}
.login-background-color > div {
  margin: auto;
}
.login-background-color > div > p {
  color: whitesmoke;
  font-size: 35px;
  margin: 0 0 40px 0;
}
.login-footer {
  margin: 50px 0 0 0;
  width: 500px;
  display: inline-block;
}
.login-background-color > section > div > label {
  color: whitesmoke;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/AppPasswordInitialization.vue